import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { api } from "../../App/API/api"

export const fetchOurStoryData = createAsyncThunk("ourstory/fetchData", async () => {
    try {
        const response=await api.get('/story');
        console.log(response)
        const data=response.data.stories
        ;
        if(response.status==200){
            return data;
        }
        
    } catch (error) {
        console.log(error)
        return error;
    }
});

export const ourStorySlice=createSlice({
    name:"ourstory",
    initialState:{
        loading:false,
        ourstory:null,
        error:""
    },
    reducers:{},
    extraReducers:(builder)=>{
        builder.addCase(fetchOurStoryData.pending,(state)=>{
            state.loading=true;
        })
        .addCase(fetchOurStoryData.fulfilled,(state,action)=>{
            state.loading=false;
            state.ourstory=action.payload;
        })
        .addCase(fetchOurStoryData.rejected,(state,action)=>{
            state.loading=false;
            state.error=action.payload;
        })
    }
})


export default ourStorySlice.reducer